import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectBibItemEntities, selectSubscriptionEntities, selectHoldingEntities } from '../EntitiesSelector';

const getAvailability = state => state.getIn(['bibs', 'availability'], Immutable.Map());

export const selectAvailabilityError = createSelector([getAvailability], availability =>
  availability.get('errorClassification')
);

export const selectBibItemsForCurrentBib = createSelector(
  [getAvailability, selectBibItemEntities],
  (availability, bibItemEntities) => availability.get('items', Immutable.List()).map(id => bibItemEntities.get(id))
);

export const selectSubscriptionsForCurrentBib = createSelector(
  [getAvailability, selectSubscriptionEntities],
  (availability, subscriptionEntities) =>
    availability.get('subscriptions', Immutable.List()).map(id => subscriptionEntities.get(id.toString()))
);

export const selectHoldingsForCurrentBib = createSelector(
  [getAvailability, selectHoldingEntities],
  (availability, holdingEntities) =>
    availability.get('holdings', Immutable.List()).map(id => holdingEntities.get(id.toString()))
);

export const selectAvailabilityProbes = createSelector([getAvailability], availability => availability.get('probes'));
